/**
 * A connected app's mark (#6559 round 17): the vendor's own glyph beside a
 * connection's name in the column and the picker, and at the right of a
 * shared drive the app owns. Named by the app, so a reader of the tree is
 * told what the glyph shows.
 */
import React from "react";
import { PlugsConnectedIcon } from "@phosphor-icons/react";
import SharePointIcon from "@/assets/Icons/ms-sharepoint.svg";
import OneNoteIcon from "@/assets/Icons/onenote.svg";
import TeamsIcon from "@/assets/Icons/microsoft-teams.svg";
import BoxIcon from "@/assets/Icons/box.svg";
import DropboxIcon from "@/assets/Icons/dropbox.svg";
import GoogleDriveIcon from "@/assets/Icons/google-drive.svg";
import DealCloudIcon from "@/assets/Icons/dealcloud.png";
import BackstopIcon from "@/assets/Icons/backstop.png";
import { appLabel } from "./browser/places";

const MARKS: Record<string, string> = {
  sharepoint: SharePointIcon,
  onenote: OneNoteIcon,
  teams: TeamsIcon,
  box: BoxIcon,
  dropbox: DropboxIcon,
  google_drive: GoogleDriveIcon,
  dealcloud: DealCloudIcon,
  backstop: BackstopIcon,
};

const AppMark: React.FC<{ app: string; size?: number }> = ({
  app,
  size = 16,
}) => {
  const src = MARKS[app];
  const label = appLabel(app);
  if (!src) {
    return (
      <PlugsConnectedIcon
        size={size}
        role="img"
        aria-label={label}
        className="shrink-0 text-[var(--fp-ink-3)]"
      />
    );
  }
  return (
    <img
      src={src}
      alt={label}
      width={size}
      height={size}
      className="shrink-0"
    />
  );
};

export default AppMark;
